var locale = {
  placeholder: 'เลือกเวลา'
};
export default locale;